import * as React from 'react';

function SvgHelpIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.35 13.016c-.04.043-.077.09-.11.137a.697.697 0 00-.083.165.588.588 0 00-.055.165 1.247 1.247 0 000 .184.77.77 0 00.073.348.824.824 0 00.495.495.862.862 0 00.697 0 .824.824 0 00.495-.495c.04-.111.06-.23.055-.348a.916.916 0 00-1.568-.651zM10 .833a9.167 9.167 0 100 18.334A9.167 9.167 0 0010 .833zm0 16.5a7.334 7.334 0 110-14.668 7.334 7.334 0 010 14.668zm0-11.916a2.75 2.75 0 00-2.383 1.375.917.917 0 101.586.916A.917.917 0 0110 7.25a.916.916 0 010 1.833.917.917 0 00-.916.917v.917a.917.917 0 001.833 0v-.165A2.75 2.75 0 0010 5.417z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgHelpIcon;
